<template>
 <div class="app" style="width: 100%;">
	  <el-container direction="vertical">
	      <el-header style="padding:0;height: auto;">
	        <IndexHead style="width:100%;"></IndexHead>
	      </el-header>
	      <el-main style="padding:0;">
			  <div class="text color flex justify-align-center" style="font-size: 23px;height:85px;margin-top: 10px;">
			     {{content.name}}
			  </div>
			  <div class="content" style="width:70%;margin: 0 auto;">
				  <div class="fuwenben" v-html="content.content"></div>
			  </div>
	      </el-main>
	     <el-footer style="padding:0;height: 30px;margin-top: 60px;width:100%;">
	     	<div class="font" style="width:100%;background: #282828;height: 50px;color:#ffffff;line-height: 50px;text-align: center;">
	     		版权所有：HR校招助手网  <span style="width: 100px;display: inline-block;"></span> CNZZ
	     	</div>
	     </el-footer>
	  </el-container>
		<div style="height: 50px;width: 100%;"></div>
  </div>
</template>

<script>
	import IndexHead from '../components/IndexHead.vue';
	export default {
		name: 'index',
		components:{
			IndexHead
		},
		data(){
		  return{
			content:''
		  }
		},
		mounted() {
			this.cooperat();
		},
		methods:{
			cooperat(){
				this.$axios
					.get(`/api/article/getBySlug?slug=introduction`)
					.then((res) => {
						// console.log(res,"res");
						this.content=res.data.data;
					});
			}
		}
	}
</script>
<style scoped lang="less">
	#app {
	  font-family: Avenir, Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  // text-align: center;
	  color: #2c3e50;
	}
	#navs{
		display:flex;
		justify-content:space-around;
	}
	#nav {
	  a {
	    font-weight: bold;
	    color: #2c3e50;
	
	    &.router-link-exact-active {
	      color: #42b983;
	    }
	  }
	}

</style>
